var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaves(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2205,
    height: 641,
    viewBox: "0 0 2205 641",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_36_132)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_n_36_132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1470 0C1435.5 0 1382.21 41.9664 1335.25 53.7373C1288.29 65.5081 1241.33 56.808 1188.25 70.626C1135.17 84.4439 1065.75 118.732 1016.75 136.645C967.75 154.557 941.208 166.328 894.25 178.099C847.292 189.869 761.542 202.408 735 207.27C708.458 202.408 622.708 189.869 575.75 178.099C528.792 166.328 502.25 154.557 453.25 136.645C404.25 118.732 334.833 84.4439 281.75 70.626C228.667 56.808 181.708 65.5081 134.75 53.7373C87.7918 41.9665 22.4585 8.95716 0 0.000976562V641.001H2205V207.27C2178.46 202.408 2092.71 189.869 2045.75 178.099C1998.79 166.328 1972.25 154.557 1923.25 136.645C1874.25 118.732 1804.83 84.4439 1751.75 70.626C1698.67 56.808 1651.71 65.5081 1604.75 53.7373C1557.79 41.9664 1504.5 0 1470 0Z",
    fill: "url(#paint0_linear_36_132)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_n_36_132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1470 49C1434.5 49 1378.13 87.48 1335.25 97.5029C1292.38 107.526 1249.5 101.163 1212.75 109.138C1176 117.112 1155.58 129.184 1114.75 145.352C1073.92 161.519 1008.58 194.072 967.75 206.144C926.917 218.215 908.542 207.755 869.75 217.778C830.958 227.801 757.458 258.197 735 266.281L732.748 265.459C707.983 256.317 637.83 227.488 600.25 217.778C561.458 207.755 543.083 218.215 502.25 206.144C461.417 194.072 396.083 161.519 355.25 145.352C314.417 129.184 294 117.112 257.25 109.138C220.5 101.163 177.625 107.526 134.75 97.5029C91.8751 87.48 22.4585 57.0849 0 49.001V641H2205V266.281C2182.54 258.197 2109.04 227.801 2070.25 217.778C2031.46 207.755 2013.08 218.215 1972.25 206.144C1931.42 194.072 1866.08 161.519 1825.25 145.352C1784.42 129.184 1764 117.112 1727.25 109.138C1690.5 101.163 1647.62 107.526 1604.75 97.5029C1561.87 87.48 1505.5 49 1470 49Z",
    fill: "url(#paint1_linear_36_132)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_n_36_132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1470 137C1437 137 1414.29 144.295 1377.25 157.155C1340.21 170.015 1282.75 199.254 1247.75 214.161C1212.75 229.068 1198.17 239.881 1167.25 246.6C1136.33 253.318 1097.25 243.658 1062.25 254.471C1027.25 265.284 992.25 296.568 957.25 311.476C922.25 326.383 889.292 335.149 852.25 343.914C815.208 352.68 754.542 360.71 735 364.069L733.05 363.74C711.69 360.207 653.634 352.406 617.75 343.914C580.708 335.149 547.75 326.383 512.75 311.476C477.75 296.568 442.75 265.284 407.75 254.471C372.75 243.658 333.667 253.318 302.75 246.6C271.833 239.881 257.25 229.068 222.25 214.161C187.25 199.254 129.792 170.015 92.75 157.155C55.7084 144.295 15.4584 140.36 0 137.001V641H2205V364.069C2185.46 360.71 2124.79 352.68 2087.75 343.914C2050.71 335.149 2017.75 326.383 1982.75 311.476C1947.75 296.568 1912.75 265.284 1877.75 254.471C1842.75 243.658 1803.67 253.318 1772.75 246.6C1741.83 239.881 1727.25 229.068 1692.25 214.161C1657.25 199.254 1599.79 170.015 1562.75 157.155C1525.71 144.295 1503 137 1470 137Z",
    fill: "url(#paint2_linear_36_132)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_n_36_132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1470 148C1422 148 1337.29 201.819 1274 219.517C1210.71 237.214 1147.42 234.441 1090.25 254.186C1033.08 273.93 990.208 316.192 931 337.983C871.792 359.775 767.667 377.109 735 384.935L733.417 384.561C699.091 376.566 597.283 359.434 539 337.983C479.792 316.192 436.917 273.93 379.75 254.186C322.583 234.441 259.292 237.214 196 219.517C132.708 201.819 32.6668 159.92 0 148.001V641.001H2205V384.935C2172.33 377.109 2068.21 359.775 2009 337.983C1949.79 316.192 1906.92 273.93 1849.75 254.186C1792.58 234.441 1729.29 237.214 1666 219.517C1602.71 201.819 1518 148 1470 148Z",
    fill: "url(#paint3_linear_36_132)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_n_36_132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1470 236C1416.5 236 1357.71 291.428 1298.5 309.937C1239.29 328.445 1180.08 330.588 1114.75 347.051C1049.42 363.514 969.792 386.113 906.5 408.713C843.208 431.312 763.583 470.326 735 482.648L732.173 481.416C701.456 467.903 624.814 430.606 563.5 408.713C500.208 386.113 420.583 363.514 355.25 347.051C289.917 330.588 230.708 328.445 171.5 309.937C112.292 291.428 28.5835 248.324 0 236.001V641.001H2205V482.648C2176.42 470.326 2096.79 431.312 2033.5 408.713C1970.21 386.113 1890.58 363.514 1825.25 347.051C1759.92 330.588 1700.71 328.445 1641.5 309.937C1582.29 291.428 1523.5 236 1470 236Z",
    fill: "url(#paint4_linear_36_132)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_n_36_132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1470 247C1422.5 247 1386.29 270.972 1335.25 286.026C1284.21 301.08 1212.75 320.226 1163.75 337.325C1114.75 354.425 1086.17 367.433 1041.25 388.623C996.333 409.813 945.292 445.32 894.25 464.465C843.208 483.61 761.542 496.987 735 503.491L733.716 503.182C705.914 496.568 625.994 483.31 575.75 464.465C524.708 445.32 473.667 409.813 428.75 388.623C383.833 367.433 355.25 354.425 306.25 337.325C257.25 320.226 185.792 301.08 134.75 286.026C83.7085 270.972 22.4584 253.505 0 247.001V641H2205V503.491C2178.46 496.987 2096.79 483.61 2045.75 464.465C1994.71 445.32 1943.67 409.813 1898.75 388.623C1853.83 367.433 1825.25 354.425 1776.25 337.325C1727.25 320.226 1655.79 301.08 1604.75 286.026C1553.71 270.972 1517.5 247 1470 247Z",
    fill: "url(#paint5_linear_36_132)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_n_36_132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1470 335C1428.5 335 1398.54 346.957 1365.88 356C1333.21 365.043 1304.62 378.171 1274 389.257C1243.38 400.342 1212.75 407.342 1182.12 422.514C1151.5 437.685 1116.79 465.114 1090.25 480.285C1063.71 495.456 1049.42 506.542 1022.88 513.542C996.333 520.542 961.625 511.199 931 522.284C900.375 533.37 871.792 566.927 839.125 580.056C806.458 593.184 752.354 597.556 735 601.056L734.16 600.891C715.961 597.417 663.031 592.979 630.875 580.056C598.208 566.927 569.625 533.37 539 522.284C508.375 511.199 473.667 520.542 447.125 513.542C420.583 506.542 406.292 495.456 379.75 480.285C353.208 465.114 318.5 437.685 287.875 422.514C257.25 407.342 226.625 400.342 196 389.257C165.375 378.171 136.792 365.043 104.125 356C71.4584 346.957 17.3543 338.501 0 335.001V641.001H2205V601.056C2187.65 597.556 2133.54 593.184 2100.88 580.056C2068.21 566.927 2039.62 533.37 2009 522.284C1978.38 511.199 1943.67 520.542 1917.12 513.542C1890.58 506.542 1876.29 495.456 1849.75 480.285C1823.21 465.114 1788.5 437.685 1757.88 422.514C1727.25 407.342 1696.62 400.342 1666 389.257C1635.38 378.171 1606.79 365.043 1574.12 356C1541.46 346.957 1511.5 335 1470 335Z",
    fill: "url(#paint6_linear_36_132)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_n_36_132",
    x: 0,
    y: 0,
    width: 2205,
    height: 641.001,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "2 2",
    stitchTiles: "stitch",
    numOctaves: 3,
    result: "noise",
    seed: 7308
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "noise",
    type: "luminanceToAlpha",
    result: "alphaNoise"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "shape",
    in: "coloredNoise1",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(0, 0, 0, 0.25)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "noise1Clipped",
    in: "color1Flood",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect1_noise_36_132"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shape"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "color1"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_n_36_132",
    x: 0,
    y: 49,
    width: 2205,
    height: 592,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "2 2",
    stitchTiles: "stitch",
    numOctaves: 3,
    result: "noise",
    seed: 7308
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "noise",
    type: "luminanceToAlpha",
    result: "alphaNoise"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "shape",
    in: "coloredNoise1",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(0, 0, 0, 0.25)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "noise1Clipped",
    in: "color1Flood",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect1_noise_36_132"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shape"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "color1"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_n_36_132",
    x: 0,
    y: 137,
    width: 2205,
    height: 504,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "2 2",
    stitchTiles: "stitch",
    numOctaves: 3,
    result: "noise",
    seed: 7308
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "noise",
    type: "luminanceToAlpha",
    result: "alphaNoise"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "shape",
    in: "coloredNoise1",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(0, 0, 0, 0.25)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "noise1Clipped",
    in: "color1Flood",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect1_noise_36_132"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shape"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "color1"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_n_36_132",
    x: 0,
    y: 148,
    width: 2205,
    height: 493.001,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "2 2",
    stitchTiles: "stitch",
    numOctaves: 3,
    result: "noise",
    seed: 7308
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "noise",
    type: "luminanceToAlpha",
    result: "alphaNoise"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "shape",
    in: "coloredNoise1",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(0, 0, 0, 0.25)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "noise1Clipped",
    in: "color1Flood",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect1_noise_36_132"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shape"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "color1"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_n_36_132",
    x: 0,
    y: 236,
    width: 2205,
    height: 405.001,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "2 2",
    stitchTiles: "stitch",
    numOctaves: 3,
    result: "noise",
    seed: 7308
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "noise",
    type: "luminanceToAlpha",
    result: "alphaNoise"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "shape",
    in: "coloredNoise1",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(0, 0, 0, 0.25)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "noise1Clipped",
    in: "color1Flood",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect1_noise_36_132"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shape"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "color1"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_n_36_132",
    x: 0,
    y: 247,
    width: 2205,
    height: 394,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "2 2",
    stitchTiles: "stitch",
    numOctaves: 3,
    result: "noise",
    seed: 7308
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "noise",
    type: "luminanceToAlpha",
    result: "alphaNoise"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "shape",
    in: "coloredNoise1",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(0, 0, 0, 0.25)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "noise1Clipped",
    in: "color1Flood",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect1_noise_36_132"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shape"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "color1"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_n_36_132",
    x: 0,
    y: 335,
    width: 2205,
    height: 306.001,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "2 2",
    stitchTiles: "stitch",
    numOctaves: 3,
    result: "noise",
    seed: 7308
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "noise",
    type: "luminanceToAlpha",
    result: "alphaNoise"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "shape",
    in: "coloredNoise1",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(0, 0, 0, 0.25)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "noise1Clipped",
    in: "color1Flood",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect1_noise_36_132"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shape"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "color1"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_36_132",
    x1: 1102.5,
    y1: -0.000488282,
    x2: 1102.5,
    y2: 641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#498A28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06140F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_36_132",
    x1: 1102.5,
    y1: 49.0005,
    x2: 1102.5,
    y2: 641.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#498A28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06140F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_36_132",
    x1: 1102.5,
    y1: 137,
    x2: 1102.5,
    y2: 641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#346520"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#061409"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_36_132",
    x1: 1102.5,
    y1: 148,
    x2: 1102.5,
    y2: 641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#204316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42D787"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_36_132",
    x1: 1102.5,
    y1: 236,
    x2: 1102.5,
    y2: 641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#339655"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#206034"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_36_132",
    x1: 1102.5,
    y1: 247,
    x2: 1102.5,
    y2: 641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#287742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D522F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_36_132",
    x1: 1102.5,
    y1: 335,
    x2: 1102.5,
    y2: 641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01BA60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A5B33"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_36_132"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2205,
    height: 641,
    fill: "white",
    transform: "matrix(-1 0 0 1 2205 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaves);
export default __webpack_public_path__ + "static/media/Waves.3f667379bdfd2cbf8f55548ad1e3bd8b.svg";
export { ForwardRef as ReactComponent };